import DetailSetUpReverseProxy from "../../../../contents/docs/integrate/_snippets/details/set-up-reverse-proxy.mdx";
import DetailGroupProductsInOneProject from "../../../../contents/docs/integrate/_snippets/details/group-products-in-one-project.mdx";
import FramerInstall from "../../../../contents/docs/integrate/_snippets/install-framer.mdx";
import * as React from 'react';
export default {
  DetailSetUpReverseProxy,
  DetailGroupProductsInOneProject,
  FramerInstall,
  React
};